import React from 'react';
import { CheckIcon } from 'lucide-react';
const capabilities = ['Custom storefront design — no templates, fully tailored to your brand', 'Payment gateway integrations (PayPal, Amazon Pay, Stripe, and more)', 'Zero transaction fees — keep more of every sale', 'Automated tax compliance with Avalara and TaxJar', 'Product feed management and Google Shopping integration', 'Inventory management, fulfillment, and supplier sync', 'SEO-optimized product pages and category structures', 'Social commerce — Facebook, Instagram, and marketplace integrations', 'Mobile-responsive shopping experiences across all devices', 'Analytics, conversion tracking, and A/B testing infrastructure', 'Subscription and recurring billing systems', 'Multi-currency and international shipping support'];
export function Capabilities() {
  return <section className="py-16" data-id="element-441">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-442">
        <div className="scroll-fade-in-up" data-id="element-443">
          <div className="bg-surface rounded-xl p-8 md:p-12" data-id="element-444">
            <h2 className="text-2xl font-bold text-ink mb-4" data-id="element-445">
              Key Capabilities
            </h2>
            <p className="text-gray-600 mb-8 leading-relaxed" data-id="element-446">
              We build conversion-optimized online stores from the ground up —
              no cookie-cutter templates. Every storefront is custom-designed
              with integrated payment processing, automated tax handling,
              inventory management, and the marketing tools you need to launch,
              grow, and scale your online business.
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-447">
              {capabilities.map((cap, i) => <li key={i} className="flex items-start" data-id="element-448">
                  <CheckIcon className="w-5 h-5 text-primary mr-3 mt-0.5 flex-shrink-0" data-id="element-449" />
                  <span className="text-gray-700" data-id="element-450">{cap}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}